import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {ARTICLE_LIST, ARTICLE_ORGANIZATION_LIST, INFORMATION_LIST} from 'manager/http-constants';
import { Table } from 'primeng/table';
import { CONSTANT, DATE_FORMAT } from 'src/app/shared/constant/constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';

@Component({
  selector: 'app-j201',
  templateUrl: './j201.component.html',
  styleUrls: ['./j201.component.scss', '../platform.component.scss'],
})

/**
 * お知らせ一覧
 */
export class J201Component extends PlatformComponent {
  // 画面.検索フォーム
  j201SearchForm: FormGroup = this.formBuilder.group({
    // 掲載開始日(FROM)
    publishe_start_FROM: CONSTANT.EMPTY_STRING,
    // 掲載終了日(TO)
    publishe_start_TO: CONSTANT.EMPTY_STRING,
  });

  @ViewChild('table') table: Table;

  // お知らせ一覧リスト結果格納先
  resultDataList: object[] = [];

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // 辞書値リストを取得
    this.getSpecCodeList(1004);

    // お知らせ一覧リスト結果を取得
    this.getResultDataList();
  }

  /**
   * お知らせ一覧リスト結果を取得
   */
  public getResultDataList(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(ARTICLE_ORGANIZATION_LIST);

    // お知らせ一覧を取得
    this.dbOperationService
      .getNoTemplateData(ARTICLE_ORGANIZATION_LIST, this.j201SearchForm.value, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // お知らせ一覧を格納
          this.resultDataList = response.body;
        } else {
          this.resultDataList = [];
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, ARTICLE_ORGANIZATION_LIST);
      });

    // テーブル状態が存在するか否か
    if (this.table) {
      // テーブル状態が存在する場合

      // テーブル状態をリセット
      this.table.reset();
    }
  }

  /**
   * 事例紹介記事詳細(J202)へ遷移する
   * @param articleId 事例紹介記事ID
   */
  public moveJ202(articleId: string): void {
    this.router.navigate(['pages/platform/j202/' + articleId]);
  }

  /**
   * 事例紹介記事登録(J203)へ遷移する
   */
  public moveJ203(): void {
    this.router.navigate(['pages/platform/j203/new'], {
      queryParams: {
        screenId: 'j203',
      },
    });
  }

  public convertToJST = datetime => {
    const date = new Date(datetime);
    const jstDate = new Date(date.getTime() + (9 * 60 * 60 * 1000));
    return jstDate.toLocaleString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }


  /**
   * 掲載タグ判定
   * @param publisheStart 掲載開始日
   * @param publisheEnd 掲載終了日
   * @returns 0:未掲載、1:掲載中、2:掲載終了
   */
  protected publisheTag(publisheStart: string, publisheEnd: string) {
    // 掲載前判定
    if (
      this.datePipe.transform(new Date(), DATE_FORMAT.DATE) <
      this.datePipe.transform(new Date(publisheStart), DATE_FORMAT.DATE)
    ) {
      // 掲載前の場合

      return 0;
    }

    // 掲載終了判定
    if (
      this.datePipe.transform(new Date(), DATE_FORMAT.DATE) >
      this.datePipe.transform(new Date(publisheEnd), DATE_FORMAT.DATE)
    ) {
      // 掲掲載終了の場合

      return 2;
    }

    return 1;
  }
}
